<template>
<div v-if="store.loading" class="about-area rn-section-gap py-10">
    <v-container>
      <v-row class="row--35" align="stretch">
        <v-col cols="12" md="6" class="d-flex justify-center align-center">
          <v-skeleton-loader
            type="image"
            height="400"
            width="100%"
            :color="style.ThemeGeneral?.TextoCss?.Color ? style.ThemeGeneral.TextoCss.Color + '10' : 'rgba(0,0,0,0.05)'"
            class="rounded-lg"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="6" class="d-flex flex-column justify-center">
          <v-skeleton-loader
            type="heading, paragraph"
            :color="style.ThemeGeneral?.TextoCss?.Color ? style.ThemeGeneral.TextoCss.Color + '10' : 'rgba(0,0,0,0.05)'"
            class="rounded-lg"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </div>

  <div class="about-area rn-section-gap" id="about" v-if="!store.loading && NOTARIA && NOTARIA.Theme && NOTARIA.Theme.Home.PN.Mostrar">
    <div class="about-wrapper">
      <v-container>
        <v-row :class="['row--35', { 'flex-row-reverse': NOTARIA.Theme.Home.PN.ImageLeft === false }]" align="stretch">
         <v-col cols="12" md="6" class="d-flex justify-center align-center">
          <div class="thumbnail">
            <v-img :src="imagenIDtoSRC(NOTARIA.Theme.Home.PN.Imagen)" :alt="'Fotografía de ' + NOTARIA.Nombre + ' - Notario'" cover/>
          </div>
        </v-col>

          <v-col cols="12" md="6" class="d-flex flex-column justify-center">
            <div class="pn content section-title-notin about-inner inner" :style="descripcionStyle">
              <h2 class="heading-title" :style="tituloStyle">
                {{ NOTARIA.Theme.Home.PN.Titulo.Texto }}
              </h2>
              <div v-if="NOTARIA.Theme.Home.PN.Descripcion.Texto" v-html="NOTARIA.Theme.Home.PN.Descripcion.Texto" class="rich-text-content">
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { useStyles } from '../../store/styles'

const { imagenIDtoSRC } = useUtils()
const store = useStore()
const { NOTARIA } = storeToRefs(store)
const style = useStyles()

const viewportWidth = ref(0)

const updateViewport = () => {
  viewportWidth.value = window.innerWidth
}

onMounted(() => {
  updateViewport()
  window.addEventListener('resize', updateViewport)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateViewport)
})


const imageMaxHeight = computed(() => {
  if (viewportWidth.value >= 1400) return '380px'
  if (viewportWidth.value >= 1024) return '320px'
  if (viewportWidth.value >= 768) return '260px'
  return '220px'
})


const tituloStyle = computed(() => ({
  color: style.ThemeHomePalabrasNotario?.Titulo?.css?.Color ?? '',
  textShadow: style.ThemeHomePalabrasNotario?.Titulo?.css?.BackgroundColor  ? `4px 2px 6px ${style.ThemeHomePalabrasNotario.Titulo.css.BackgroundColor}` : '',
  fontFamily: style.ThemeHomePalabrasNotario?.Titulo?.css?.Font ?? '',
  fontSize: style.ThemeHomePalabrasNotario?.Titulo?.css?.Size ?? '',
  fontWeight: style.ThemeHomePalabrasNotario?.Titulo?.css?.Weight ?? '',
  textAlign: style.ThemeHomePalabrasNotario?.Titulo?.css?.Align ?? ''
}))

const descripcionStyle = computed(() => ({
  color: style.ThemeHomePalabrasNotario?.Descripcion?.css?.Color ?? '',
  textShadow: style.ThemeHomePalabrasNotario?.Descripcion?.css?.BackgroundColor ? `4px 2px 6px ${style.ThemeHomePalabrasNotario.Descripcion.css.BackgroundColor}` : '',
  fontFamily: style.ThemeHomePalabrasNotario?.Descripcion?.css?.Font ?? '',
  fontSize: style.ThemeHomePalabrasNotario?.Descripcion?.css?.Size ?? '',
  fontWeight: style.ThemeHomePalabrasNotario?.Descripcion?.css?.Weight ?? '',
  textAlign: style.ThemeHomePalabrasNotario?.Descripcion?.css?.Align ?? ''
}))
</script>

<style scoped lang="scss">
.rich-text-content {
  color: inherit;
  font-family: inherit;
  text-align: inherit;
  font-size: inherit;
  
  :deep(p), :deep(ul), :deep(ol), :deep(li), :deep(span) {
    color: inherit;
    font-family: inherit;
    text-align: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  :deep(strong), :deep(b) {
    font-weight: bold !important;
  }
}
.thumbnail {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.thumbnail img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; 
}

.pn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
</style>